function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 35,
  opacity: 0.3,
  fill: "none",
  stroke: "#00A4E4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36 19v33m17-17L36 52m18-8V34H44m-25 1l17 17m-18-8V34h10m15-8l-7-7-7 7",
  fill: "none",
  stroke: "#00A4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgRoute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MiA3MiI+PGNpcmNsZSBjeD0iMzYiIGN5PSIzNiIgcj0iMzUiIG9wYWNpdHk9Ii4zIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMEE0RTQiIHN0cm9rZVdpZHRoPSIxLjUiLz48cGF0aCBkPSJNMzYgMTl2MzNtMTctMTdMMzYgNTJtMTgtOFYzNEg0NG0tMjUgMWwxNyAxN20tMTgtOFYzNGgxMG0xNS04bC03LTctNyA3IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMEE0RTQiIHN0cm9rZVdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";
export { SvgRoute as ReactComponent };